export const DEFAULT_PROMOTION_GIFT_QUANTITY = 1;

export const normalizePromotionGiftDefaultQuantity = (value) => {
  const numberValue = value === null || value === undefined || value === ''
    ? DEFAULT_PROMOTION_GIFT_QUANTITY
    : Number(value);

  return Number.isInteger(numberValue) && numberValue > 0
    ? numberValue
    : DEFAULT_PROMOTION_GIFT_QUANTITY;
};

export const normalizePromotionGiftRows = (rows = []) =>
  (Array.isArray(rows) ? rows : []).map((row) => ({
    ...row,
    default_quantity: normalizePromotionGiftDefaultQuantity(row?.default_quantity),
  }));
